export default "__VITE_ASSET__2c0815e4__"